<!-- CategoriesFilter - specific category selection - for desktop and mobile devices -->
<template>
  <PlatformRenderer>
    <!-- START: Desktop Category Filter -->
    <template v-slot:onDesktop>
      <!-- START: Collapse card -->
      <WCCollapseCard
        class="mb-3 mt-1 border-0"
        headerClass="mb-2"
        headerBackground="var(--secondary-lighter-7)"
        bodyClass="p-0 mb-3"
      >
        <!-- START: Card Title -->
        <template v-slot:headerTitle>
          <h4 class="my-auto">{{ $t('categories') }}</h4>
        </template>
        <!-- END: Card Title -->

        <!-- START : Card Body -->
        <template v-slot:cardBody>
          <div class="wc-wrapper-scroll overflow-auto pl-4 pr-4">
            <div
              class="row justify-content-between py-1 border-bottom"
              v-for="group in groupChildren"
              :key="group.id"
            >
              <div class="wc-filter-checkbox">
                <WCCheckbox
                  :id="'search-filter-checkbox-' + group.id"
                  :model="group.selected"
                  :label="group.name"
                  @change="groupChanged(group)"
                >
                  <WCSearchFilterCategoryItem :itemValue="group.name" />
                </WCCheckbox>
              </div>
            </div>
          </div>
        </template>
        <!-- END : Card Body -->
      </WCCollapseCard>
      <!-- END: Collapse card -->
    </template>
    <!-- END: Desktop Category Filter -->

    <!-- START: Mobile Category Filter -->
    <template v-slot:onMobile>
      <!-- START : Category Filter Card -->
      <div class="pt-1 mt-3">
        <div class="row wc-category-hdr pl-3 py-1 mb-3">
          {{ $t('categories') }}
        </div>

        <div v-for="group in groupChildren" :key="group.id">
          <WCCheckbox
            :id="'search-filter-checkbox-' + group.id"
            class="p-0 wc-mobile-filter-checkbox"
            :model="group.selected"
            :label="group.name"
            @change="groupChanged(group)"
          >
            <WCSearchFilterCategoryItem :itemValue="group.name" />
          </WCCheckbox>
          <hr class="row" />
        </div>
      </div>

      <!-- END : Category Filter Card -->
    </template>
    <!-- END: Mobile Category Filter -->
  </PlatformRenderer>
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import WCSearchFilterCategoryItem from '@/components/WCSearchFilterCategoryItem/WCSearchFilterCategoryItem.vue';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import WCCollapseCard from '../WCCollapseCard/WCCollapseCard.vue';

export default {
  components: { PlatformRenderer, WCCheckbox, WCCollapseCard, WCSearchFilterCategoryItem },
  emits: ['groupChanged'],
  props: {
    groupChildren: {
      type: Array,
      required: true,
    },
  },
  methods: {
    /**
     * method triggered on change of specific category group
     */
    groupChanged(group) {
      this.$emit('groupChanged', group);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-mobile-filter-checkbox {
  display: inline;
  margin-left: $margin-4;
}

.wc-category-hdr {
  background-color: var(--secondary-lighter-6, get-color('secondary', 'lighter-6'));
  font-size: $font-size-lg;
  font-weight: 700;
}

::v-deep.wc-filter-checkbox {
  max-width: 75%;
  .custom-control-label {
    width: 100%;
  }
}
</style>
